import { Layout } from "antd";
import React from "react";
import styled from "styled-components";
import LogoImg from "../../assets/logo.svg";
import { useLocation } from "react-router-dom";
import { ZipChip } from "./ZipChip";

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-right: 2rem;

  @media (max-width: 500px) {
    padding-right: 0;
  }

  h1 > a {
    font-family: "Palanquin" !important;
    color: #323593;
    font-weight: bold;
    font-size: 2rem;
    display: block;
    margin-top: 1rem;
    margin-bottom: 0;
  }
  h1 {
    margin-bottom: 0;
  }
  span {
    color: #03a4ff;
  }
`;

export const Logo = () => {
  const { pathname } = useLocation();
  const isTasksPage = pathname === "/tasks";
  return (
    <Layout className="step-layout">
      <LogoContainer>
        <div>
          <h1>
            <a href="https://heyhomero.com" title="Homero's website">
              <img src={LogoImg} alt="Homero Logo" title="Homero Logo" />
            </a>
          </h1>
          {isTasksPage ? (
            <span>Pay by task, not by time</span>
          ) : (
            <span>Happiness is a clean home.</span>
          )}
        </div>
        <ZipChip />
      </LogoContainer>
    </Layout>
  );
};
